import { contactRoleLabelForDisplay } from "./contactRoleLabel";
import { getMessagingRoleLabel } from "./roles";

/**
 * @param {object} contacto
 * @returns {string}
 */
export function formatMessagingContactLabel(contacto) {
  if (!contacto || typeof contacto !== "object") {
    return "";
  }
  const nombre = typeof contacto.nombre === "string" ? contacto.nombre.trim() : "";
  const apellido =
    typeof contacto.primerApellido === "string"
      ? contacto.primerApellido.trim()
      : typeof contacto.apellido === "string"
        ? contacto.apellido.trim()
        : "";
  const full = [nombre, apellido].filter(Boolean).join(" ").trim();
  const rol = contactRoleLabelForDisplay(contacto);
  const rolLabel = getMessagingRoleLabel(String(rol));
  const identity = full && rolLabel ? `${full} · ${rolLabel}` : full || nombre || "(sin nombre)";
  const email = typeof contacto.email === "string" ? contacto.email.trim() : "";
  return email ? `${identity} — ${email}` : identity;
}
